import React from 'react';

type MenuItem = {label: string; href: string};

const MENU_ITEMS: MenuItem[] = [
  {label: 'ACミハラについて', href: '/about'},
  {label: '料金施設', href: '/facility'},
  {label: '運営会社', href: '/company'},
  {label: '利用規約', href: '/terms'},
  {label: 'プライバシーポリシー', href: '/privacy'},
  {label: '特定商取引法に基づく表示', href: '/trade'},
  {label: 'お問い合わせ', href: '/contact'},
];

type Props = {active: string};

export const PageMenu: React.FC<Props> = ({active}) => (
  <section className="h-16 bg-neutral-100">
    <div className="mx-auto h-full max-w-[840px]">
      <ul className="flex h-full list-none p-0">
        {MENU_ITEMS.map(({label, href}) => (
          <li key={href} className="m-auto">
            <a
              href={href}
              className={active === href ? 'text-primary' : 'text-neutral-900'}>
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
